import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "spacing"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React from 'react';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
var ListElement = styled.ul.withConfig({
  displayName: "BulletList__ListElement",
  componentId: "sc-1ihjuaw-0"
})(["list-style:disc;"]);
var ListItem = styled.li.withConfig({
  displayName: "BulletList__ListItem",
  componentId: "sc-1ihjuaw-1"
})(["margin-left:", ";padding-bottom:", ";&:last-child{padding-bottom:0;}"], function (p) {
  return p.theme.globals.spacing.m;
}, function (p) {
  return p.theme.globals.spacing[p.spacing];
});
var BulletList = function BulletList(_ref) {
  var children = _ref.children,
    _ref$spacing = _ref.spacing,
    spacing = _ref$spacing === void 0 ? 'xxs' : _ref$spacing,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(ListElement, _objectSpread(_objectSpread({}, otherProps), {}, {
    children: React.Children.map(children, function (child, i) {
      if (child) {
        return /*#__PURE__*/_jsx(ListItem, {
          spacing: spacing,
          children: child
        }, i);
      }
    })
  }));
};
export default BulletList;